/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const meetingParticipantSchema = z.object({
  attendeeName: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  joinedAt: z.string().datetime().nullish(),
  leftAt: z.string().datetime().nullish(),
  updatedAt: z.string().datetime().nullish(),
  zoomId: z.string().nullish(),
});

export type MeetingParticipant = z.infer<typeof meetingParticipantSchema>;
